// src/components/forms/formSteps/WhenStep.tsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";

interface WhenStepProps {
  state?: string;
  dateSelection?: string; // Make it optional
  onChange: (field: string, value: string) => void;
  isSubmitting: boolean;
}

const WhenStep: React.FC<WhenStepProps> = ({
  state,
  dateSelection,
  onChange,
  isSubmitting,
}) => {
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 1 }}>
        Question 5 out of 5
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 2 }}>
        5. When did the accident happen?
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Button
          disabled={isSubmitting}
          variant="outlined"
          sx={{
            p: 1.2,
            borderRadius: 2,
            justifyContent: "center",
            borderColor:
              dateSelection === "lessthan3monthsCA" ? "#1976d2" : "#ccc",
            backgroundColor:
              dateSelection === "lessthan3monthsCA"
                ? "rgba(25, 118, 210, 0.04)"
                : "transparent",
            color: "#000",
            "&:hover": {
              borderColor: "#1976d2",
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
          onClick={() => onChange("accidentDateSelection", "lessthan3monthsCA")}
        >
          Less than 3 months
        </Button>

        <Button
          disabled={isSubmitting}
          variant="outlined"
          sx={{
            p: 1.2,
            borderRadius: 2,
            justifyContent: "center",
            borderColor:
              dateSelection === "lessthan6monthsCA" ? "#1976d2" : "#ccc",
            backgroundColor:
              dateSelection === "lessthan6monthsCA"
                ? "rgba(25, 118, 210, 0.04)"
                : "transparent",
            color: "#000",
            "&:hover": {
              borderColor: "#1976d2",
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
          onClick={() => onChange("accidentDateSelection", "lessthan6monthsCA")}
        >
          3 to 6 months ago
        </Button>
        <Button
          disabled={isSubmitting}
          variant="outlined"
          sx={{
            p: 1.2,
            borderRadius: 2,
            justifyContent: "center",
            borderColor:
              dateSelection === "lessthanyearCA" ? "#1976d2" : "#ccc",
            backgroundColor:
              dateSelection === "lessthanyearCA"
                ? "rgba(25, 118, 210, 0.04)"
                : "transparent",
            color: "#000",
            "&:hover": {
              borderColor: "#1976d2",
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
          onClick={() => onChange("accidentDateSelection", "lessthanyearCA")}
        >
          6 to 12 months ago
        </Button>
        <Button
          variant="outlined"
          disabled={isSubmitting}
          sx={{
            p: 1.2,
            borderRadius: 2,
            justifyContent: "center",
            borderColor:
              dateSelection === "within2yearsCA" ? "#1976d2" : "#ccc",
            backgroundColor:
              dateSelection === "within2yearsCA"
                ? "rgba(25, 118, 210, 0.04)"
                : "transparent",
            color: "#000",
            "&:hover": {
              borderColor: "#1976d2",
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
          onClick={() => onChange("accidentDateSelection", "within2yearsCA")}
        >
          1 to 2 years ago
        </Button>

        <Button
          variant="outlined"
          disabled={isSubmitting}
          sx={{
            p: 1.2,
            borderRadius: 2,
            justifyContent: "center",
            borderColor:
              dateSelection === "moreThan2yearsCA" ? "#1976d2" : "#ccc",
            backgroundColor:
              dateSelection === "moreThan2yearsCA"
                ? "rgba(25, 118, 210, 0.04)"
                : "transparent",
            color: "#000",
            "&:hover": {
              borderColor: "#1976d2",
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
          onClick={() => onChange("accidentDateSelection", "moreThan2yearsCA")}
        >
          More than 2 years
        </Button>
      </Box>
    </>
  );
};

export default WhenStep;
